exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.profile-header-img .btn-cancel[data-v-40e1af7e] {\ncolor: green;\nposition: absolute;\nleft: 4px;\nbottom: 4px;\nbackground-color: white;\nborder: 1px solid lightgrey;\n}\n.profile-header-img .btn-confirm[data-v-40e1af7e] {\ncolor: red;\nposition: absolute;\nright: 4px;\nbottom: 4px;\nbackground-color: white;\nborder: 1px solid lightgrey;\n}\n.current-avatar[data-v-40e1af7e] {\nborder: 2px solid #c30057;\n}\n", ""]);

// exports
